// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.design-container {
    display: flex;
    gap: 10px;
    padding: 0 15px;
    border-radius: 8px;
    width: fit-content;
    margin: 20px auto;
}

.symbol {
    font-size: 24px;
    font-weight: bold;
    background-color: var(--f5-chatAdmin-body-background);
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 1px solid var(--cb-border);
    transition: all 0.3s ease;
    cursor: pointer;

    svg {
        color: var(--_10a37f-background);
        fill: var(--_10a37f-background);
        width: 25px;
    }
}

.symbol:hover {
    background-color: var(--_16c0982e-background);
    transform: scale(1.1);
    box-shadow: 0 4px 8px var(--black-005-shadow);
}


.symbolExtra {
    font-size: 24px;
    font-weight: bold;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.3s ease;
    svg {
        width: 25px;
    }
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/contacts/SymbolDesign.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,qDAAqD;IACrD,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kCAAkC;IAClC,yBAAyB;IACzB,eAAe;;IAEf;QACI,gCAAgC;QAChC,+BAA+B;QAC/B,WAAW;IACf;AACJ;;AAEA;IACI,6CAA6C;IAC7C,qBAAqB;IACrB,6CAA6C;AACjD;;;AAGA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB;QACI,WAAW;IACf;IACA,eAAe;AACnB","sourcesContent":[".design-container {\n    display: flex;\n    gap: 10px;\n    padding: 0 15px;\n    border-radius: 8px;\n    width: fit-content;\n    margin: 20px auto;\n}\n\n.symbol {\n    font-size: 24px;\n    font-weight: bold;\n    background-color: var(--f5-chatAdmin-body-background);\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    border: 1px solid var(--cb-border);\n    transition: all 0.3s ease;\n    cursor: pointer;\n\n    svg {\n        color: var(--_10a37f-background);\n        fill: var(--_10a37f-background);\n        width: 25px;\n    }\n}\n\n.symbol:hover {\n    background-color: var(--_16c0982e-background);\n    transform: scale(1.1);\n    box-shadow: 0 4px 8px var(--black-005-shadow);\n}\n\n\n.symbolExtra {\n    font-size: 24px;\n    font-weight: bold;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    transition: all 0.3s ease;\n    svg {\n        width: 25px;\n    }\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
